/**
 * Renders one CSV import error as a single line for the dialog's error list.
 *
 * The backend's `CsvValidationError` carries `lineNumber` and `fieldName`; other error shapes
 * reaching this dialog use `line`, or are plain strings. Losing the location turns an actionable
 * message ("line 42, Predecessors: …") into an unlocatable one, so both are surfaced when present.
 */
export const formatImportError = (error, t) => {
  if (typeof error === "string") return error;

  const line = error.lineNumber ?? error.line;
  const location = [
    line ? t("library.import.errorLine", "Line {{line}}", { line }) : null,
    error.fieldName || null,
  ]
    .filter(Boolean)
    .join(" · ");

  return location ? `${location}: ${error.message}` : error.message || String(error);
};
